var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","transform":"rotate(90 16 16)","fill":"#29DDCC","key":0}),React.createElement("path",{"d":"M21 14L16 20L11 14","stroke":"#0C0D0F","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

DownArrow.defaultProps = {"aria-hidden":"1","width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
